import axios from 'axios';

export default axios.create({
  baseURL: '/api',
  //baseURL: 'http://play.jcorpbattleofgods.com:5080/api',
  headers: {
    'Content-type': 'application/json'
  }
});
